import dayjs from 'dayjs';
import { CHAT_TYPES } from 'constants';

export function isPrivateChat(chat) {
  return chat.type === CHAT_TYPES.DIRECT;
}

export function genUserOnlineStatus(user) {
  if (user.is_online) {
    return 'آنلاین';
  }

  if (user.last_online) {
    return dayjs(user.last_online).fromNow();
  }

  return null;
}
